import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import './NewsletterBox.css';

const NewsletterBox = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    // Simulate API call
    setTimeout(() => {
      console.log('Newsletter signup:', email);
      setStatus('success');
      setEmail('');
      
      // Reset after 3 seconds
      setTimeout(() => setStatus('idle'), 3000);
    }, 1000);
  };

  return (
    <div className="newsletter-box">
      <div className="newsletter-icon">
        <Mail size={32} />
      </div>
      <h3 className="newsletter-title">Get Financial Insights Weekly</h3>
      <p className="newsletter-description">
        Join 5,000+ finance professionals receiving expert tips
      </p>

      <form className="newsletter-form" onSubmit={handleSubmit}>
        <input
          type="email"
          className="newsletter-input"
          placeholder="Your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={status === 'loading' || status === 'success'}
        />
        <button 
          type="submit" 
          className="newsletter-button"
          disabled={status === 'loading' || status === 'success'}
        >
          {status === 'loading' ? 'Subscribing...' : 
           status === 'success' ? 'Subscribed!' : 
           'Subscribe'}
        </button>
      </form>

      <p className="newsletter-privacy">
        We respect your privacy. Unsubscribe anytime.
      </p>
    </div>
  );
};

export default NewsletterBox;